import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash'
    import { ref, computed, watch, useTemplateRef } from 'vue';
    import InvoiceInformation from '../../module/common/models/InvoiceInformation.ts'
    import Invoice from '../../module/common/models/Invoice.ts';
    import File from '../../module/common/models/File.ts';
    import { Size } from '../../components/basic_button/size.ts'
    import { store as data_store } from '../../store.ts';

    interface Props {
        file: File | null,
        invoices: Invoice[],
        is_stamping: boolean
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'invoice_information_edit',
  props: {
    file: { type: [Object, null], required: true },
    invoices: { type: Array, required: true },
    is_stamping: { type: Boolean, required: true }
  },
  emits: ['update_invoice', 'start_stamping', 'cancel_stamping', 'toggle_invoice_comparison'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

    const store = data_store()

    const props = __props
    const emit = __emit
    const invoice_information = ref(new InvoiceInformation())

    const project_loading = ref(false)

    const invoice = computed(() => {
        const loc_invoices = props.invoices

        if (loc_invoices.length > 1) {
            return null
        } else if (loc_invoices.length === 1) {
            return loc_invoices[0]
        } else {
            return null
        }
    })

    const multiple_invoices_selected = computed(() => {
        const loc_invoices = props.invoices

        if (loc_invoices.length > 1) {
            return true
        } else {
            return false
        }
    })

    const disabled = computed(() => {
        const loc_invoice = invoice.value

        if (loc_invoice === null) {
            return true
        } else if (!loc_invoice.id) {
            return true
        } else {
            return false
        }
    })

    const is_stamping = computed(() => props.is_stamping)

    const update_invoice = _.debounce((arg_file: File | null, arg_invoice: Invoice | null, arg_invoice_information: InvoiceInformation) => {
        if (arg_file === null || arg_invoice === null) {
            return
        }
        let updated_invoice_information = new InvoiceInformation()
        updated_invoice_information.vendor = arg_invoice_information.vendor 
        updated_invoice_information.project_NaN = arg_invoice_information.project_NaN 
        updated_invoice_information.project_description = arg_invoice_information.project_description 
        updated_invoice_information.customer = arg_invoice_information.customer 
        updated_invoice_information.project_manager = arg_invoice_information.project_manager 
        updated_invoice_information.invoice_NaN = arg_invoice_information.invoice_NaN 
        updated_invoice_information.total = arg_invoice_information.total

        emit('update_invoice', arg_file, { ...arg_invoice, invoice_information: updated_invoice_information })
    }, 500);

    function fetch_project_data(arg_file: File | null, arg_invoice: Invoice | null, arg_project_or_purchase_order_number: string) {
        if (arg_file !== null && arg_invoice !== null) {
            project_loading.value = true
            //We need to wait for the debouced invoice update to finish
            setTimeout(async () => {
                try {
                    await store.fetch_project_data(arg_file.id, arg_invoice.id, arg_project_or_purchase_order_number)
                    project_loading.value = false
                } catch (e) {
                    project_loading.value = false
                    throw e
                }
            }, 550)
        }
    }

    const start_stamping = () => {
        if (is_stamping.value) {
            emit('cancel_stamping')
        } else {
            emit('start_stamping')
        }
    }

    const toggle_invoice_comparison = function() {
        emit('toggle_invoice_comparison')
    }

    watch(
        invoice,
        (new_invoice) => {
            if(!new_invoice) {
                return
            }
            const loc_invoice = new_invoice
            const loc_invoice_information = new InvoiceInformation()

            loc_invoice_information.vendor              = loc_invoice.invoice_information.vendor;
            loc_invoice_information.project_NaN         = loc_invoice.invoice_information.project_NaN;
            loc_invoice_information.project_description = loc_invoice.invoice_information.project_description;
            loc_invoice_information.customer            = loc_invoice.invoice_information.customer;
            loc_invoice_information.project_manager     = loc_invoice.invoice_information.project_manager;
            loc_invoice_information.invoice_NaN         = loc_invoice.invoice_information.invoice_NaN;
            loc_invoice_information.total               = loc_invoice.invoice_information.total;

            invoice_information.value = loc_invoice_information
        },
        { immediate: true, deep: true }
    );


const __returned__ = { store, props, emit, invoice_information, project_loading, invoice, multiple_invoices_selected, disabled, is_stamping, update_invoice, fetch_project_data, start_stamping, toggle_invoice_comparison, get Size() { return Size } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})